module.exports = __webpack_public_path__ + "img/sensitive-skin.4d006271.svg";